import React, { useState, useEffect } from "react";
import { Input, Divider, Checkbox } from "antd";
import Card from "../../components/card";
import StyledButton from "../../components/styledButton";
import Button from "../../components/genericButton";
import styles from "./style.module.scss";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { auth } from "../../firebase";
import { withRouter } from "react-router-dom";
import profileActions from "../../redux/profile/actions";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../assets/images/branding/CREDITZ-WHITE.png";

function SignIn(props) {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  async function login() {
    if (!userName || !password) {
      return;
    }
    dispatch({
      type: profileActions.AUTH_USER,
      payload: {
        userName,
        password,
      },
    });
  }

  return (
    <div className={styles.mainComponent}>
      <img src={logo} alt="Logo" className={styles.logo} />
      <Card className={styles.card} title="My Name Is..." bordered={false}>
        <Input
          className={styles.inputs}
          placeholder="Email"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
        />
        <Input.Password
          className={styles.inputs}
          placeholder="input password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
        />
        <div className={styles.signIn}>
          <Checkbox style={{ marginBottom: "10px" }}>
            Keep me logged in
          </Checkbox>
          <StyledButton onClick={login} title="Sign In" />
        </div>

        <Divider />

        <div className={styles.signUp}>
          <p>Not a User?</p>
          <Link style={{ marginLeft: "10px" }} to="/signUp">
            <Button type="link" title="Sign Up" />
          </Link>
        </div>
      </Card>
    </div>
  );
}

export default withRouter(SignIn);
